var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsabilityTesting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H35.9883C42.6157 0 47.9883 5.37258 47.9883 12V35.9883C47.9883 42.6157 42.6157 47.9883 35.9883 47.9883H12C5.37258 47.9883 0 42.6157 0 35.9883V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0627 23.6463C13.9794 23.8707 13.9794 24.1175 14.0627 24.3419C14.8739 26.3087 16.2508 27.9905 18.0189 29.1738C19.787 30.3572 21.8667 30.9889 23.9942 30.9889C26.1218 30.9889 28.2015 30.3572 29.9696 29.1738C31.7377 27.9905 33.1146 26.3087 33.9258 24.3419C34.0091 24.1175 34.0091 23.8707 33.9258 23.6463C33.1146 21.6795 31.7377 19.9977 29.9696 18.8144C28.2015 17.631 26.1218 16.9993 23.9942 16.9993C21.8667 16.9993 19.787 17.631 18.0189 18.8144C16.2508 19.9977 14.8739 21.6795 14.0627 23.6463Z",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9941 26.9922C25.6499 26.9922 26.9922 25.6499 26.9922 23.9941C26.9922 22.3384 25.6499 20.9961 23.9941 20.9961C22.3384 20.9961 20.9961 22.3384 20.9961 23.9941C20.9961 25.6499 22.3384 26.9922 23.9941 26.9922Z",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsabilityTesting);
export default __webpack_public_path__ + "static/media/Usability Testing.9bff356fbd6cafc55fe2039ae7b104c0.svg";
export { ForwardRef as ReactComponent };